const getters = {
  getList: (state) => state.list,
  getPageInfo: (state) => state.pageInfo,
  getCondition: (state) => state.condition,
  getDetail: (state) => state.detail
};
export default getters;
